import { TrendingTopic } from './entities';

export class TrendingTopicsStore {
  private trendingTopics?: TrendingTopic[];
  private trendingIndiaTopics?: TrendingTopic[];
  private lastUpdated?: number;
  private trendingIndiaTopicsLastUpdated?: number;

  constructor() {
    this.trendingTopics = undefined;
    this.trendingIndiaTopics = undefined;
    this.lastUpdated = undefined;
    this.trendingIndiaTopicsLastUpdated = undefined;
  }

  public setTrendingTopics = (trendingTopics: TrendingTopic[]) => {
    this.trendingTopics = trendingTopics;
    this.lastUpdated = Date.now();
  };

  public getTrendingTopics = (): TrendingTopic[] => {
    return this.trendingTopics ?? [];
  };

  public shouldFetchTrendingTopics = (maxAgeMs = 60 * 1000): boolean => {
    if (!this.trendingTopics) return true;
    if (!this.lastUpdated) return true;
    return Date.now() - this.lastUpdated > maxAgeMs;
  };

  public setTrendingIndiaTopics = (trendingIndiaTopics: TrendingTopic[]) => {
    this.trendingIndiaTopics = trendingIndiaTopics;
    this.trendingIndiaTopicsLastUpdated = Date.now();
  };

  public getTrendingIndiaTopics = (): TrendingTopic[] => {
    return this.trendingIndiaTopics ?? [];
  };

  public shouldFetchTrendingIndiaTopics = (maxAgeMs = 60 * 1000): boolean => {
    if (!this.trendingIndiaTopics) return true;
    if (!this.trendingIndiaTopicsLastUpdated) return true;
    return Date.now() - this.trendingIndiaTopicsLastUpdated > maxAgeMs;
  };
}
